// extracted by mini-css-extract-plugin
export default {"account-row":"UserAdminAccount_account-row__d1Pwj","button-width":"UserAdminAccount_button-width__x56hQ"};